export default "__VITE_ASSET__DMsyJujL__"